import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedLanguage: '',
  alertVisible: false,
  alertMessage: '',
}

const languageSelectionSlice = createSlice({
  name: 'LanguageSelectionSlice',
  initialState,
  reducers: {
    setSelectedLanguage: (state, action) => {
      state.selectedLanguage = action.payload
    },
    setAlertVisibleL: (state, action) => {
      state.alertVisible = action.payload
    },
    setAlertMessageL: (state, action) => {
      state.alertMessage = action.payload
    },
    resetLanguageForm: () => initialState
  }
})

export const {
  setSelectedLanguage, setAlertVisibleL, setAlertMessageL, resetLanguageForm
} = languageSelectionSlice.actions
export default languageSelectionSlice.reducer
